import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import IconBackChevronSvg from '../../../assets/icons/icon-back-chevron.svg?react';
import LogoMarkSvg from '../../../assets/logos/logo-mark.svg?react';
import { BaseButton } from '../../../shared/ui';

import { LoginHeaderActions } from './login-header-actions';

type AuthTopBarProps = {
  backActionAriaLabel?: string;
  onBack?: () => void;
  showHelpNotificationBadge?: boolean;
};

const TopBar = styled.header.attrs({
  'data-ui': 'auth-top-bar',
})`
  min-height: ${({ theme }) => theme.scale.px(39)};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

const BrandRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.scale.px(18)};
`;

const BrandCluster = styled.div`
  display: grid;
  align-content: start;
  gap: ${({ theme }) => theme.scale.px(3)};
`;

const BackAction = styled(BaseButton)`
  width: ${({ theme }) => theme.scale.px(24)};
  height: ${({ theme }) => theme.scale.px(24)};
  margin-top: ${({ theme }) => theme.scale.px(8)};
  display: grid;
  place-items: center;
`;

const BackIcon = styled(IconBackChevronSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: ${({ theme }) => theme.scale.px(12)};
  height: ${({ theme }) => theme.scale.px(20)};
  display: block;
  color: ${({ theme }) => theme.colors.text.primary};

  & path {
    stroke: currentColor;
  }
`;

const LogoMark = styled(LogoMarkSvg)`
  width: ${({ theme }) => theme.scale.px(108)};
  height: ${({ theme }) => theme.scale.px(31)};
  flex: 0 0 auto;
  display: block;
  color: ${({ theme }) => theme.colors.text.primary};
  --logo-mark-accent: ${({ theme }) => theme.colors.brand.primary};
`;

const BrandTagline = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.scale.px(8)};
  font-weight: 600;
  line-height: 1.18;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export function AuthTopBar({
  backActionAriaLabel,
  onBack,
  showHelpNotificationBadge = false,
}: AuthTopBarProps) {
  const { t } = useTranslation();

  return (
    <TopBar>
      <BrandRow>
        {onBack && backActionAriaLabel && (
          <BackAction
            aria-label={backActionAriaLabel}
            type="button"
            onClick={onBack}
          >
            <BackIcon />
          </BackAction>
        )}
        <BrandCluster>
          <LogoMark role="img" aria-label="grato" />
          <BrandTagline>{t('homeDashboard.brandTagline')}</BrandTagline>
        </BrandCluster>
      </BrandRow>

      <LoginHeaderActions
        showHelpNotificationBadge={showHelpNotificationBadge}
      />
    </TopBar>
  );
}
